import { create } from 'zustand'
import { Case, Patient } from '../interfaces/Patient'

interface PatientStoreState {
    patient: Patient | null
    updatePatient: (body: Partial<Patient>) => void
    setPatient: (patient: Patient) => void
    case: Case | null
    setCase: (caso: Case) => void
    updateCase: (body: Partial<Case>) => void
}

const usePatientStore = create<PatientStoreState>()((set) => ({
    patient: null,
    case: null,
    updatePatient: (body) => {
        set((state) => {
            if (!state.patient) {
                console.error('Patient must be initialized before updating');
                return state;
            }
            const newPatient: Patient = { ...state.patient, ...body };
            return { patient: newPatient };
        });
    },
    updateCase: (body) => {
        set((state) => {
            if (!state.case) {
                console.error('Case must be initialized before updating');
                return state;
            }
            const newCase: Case = { ...state.case, ...body };
            return { case: newCase };
        });
    },
    setPatient: (patient) => set(() => ({ patient: patient })),
    setCase: (caso) => set(() => ({ case: caso })),
}));

export default usePatientStore;